// src/Components/Modal/index.jsx
import { useEffect } from "react";
import { RxCross2 } from "react-icons/rx";

export const Modal = ({
  showModal,
  setShowModal,
  children,
  customClasses = "",
}) => {
  useEffect(() => {
    document.body.style.overflowY = showModal ? "hidden" : "auto";
    return () => { document.body.style.overflowY = "auto"; };
  }, [showModal]);

  if (!showModal) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm animate-fade-in"
        onClick={() => setShowModal(false)}
      />

      {/* Panel */}
      <div
        id="modal"
        className={`
          relative z-10 w-full rounded-2xl overflow-y-auto max-h-[92vh]
          cw-surface border cw-border shadow-2xl
          animate-scale-in
          sm:max-w-xl md:max-w-4xl
          ${customClasses}
        `}
        style={{ boxShadow: "var(--shadow-xl)" }}
      >
        {children}

        {/* Close button */}
        <button
          onClick={() => setShowModal(false)}
          className="
            absolute top-3 right-3 z-20
            p-2 rounded-lg
            bg-sky-100 hover:bg-sky-200
            border border-sky-200 hover:border-sky-300
            text-sky-600 hover:text-sky-800
            shadow-sm
            transition-all duration-200
          "
          aria-label="Close"
        >
          <RxCross2 size={20} />
        </button>
      </div>
    </div>
  );
};
